// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__389YX","toggleWrap":"styles_toggleWrap__2dAls","content":"styles_content__3uOjJ","selectAreaCode":"styles_selectAreaCode__1n5D9"};